"use strict";
var twentyninetimes = twentyninetimes || {};

twentyninetimes.pricingtable =
  twentyninetimes.pricingtable ||
  (function () {
    function init() {
      const pricingTables = document.querySelectorAll(".block-pricing-table");

      const currentView = getQueryParam("priceview");

      if (pricingTables) {
        pricingTables.forEach((table) => {
          const switcher = table.querySelector(".block-pricing-table-switcher");
          const pricelines = table.querySelectorAll(".price");
          
          if(switcher) {
            const optionMonthly = switcher.querySelector(
              '[data-option="monthly"',
              );
            const optionYearly = switcher.querySelector('[data-option="yearly"');
            const switchOptions = switcher.querySelectorAll(".switcher-option");
              switchOptions.forEach((option) => {
                if (currentView && option.dataset.option == currentView) {
                  option.classList.add("current-view");
                } else if (!currentView) {
                  optionMonthly.classList.add("current-view");
                }
    
                option.addEventListener("click", () => {
                  switchOptions.forEach((option) => {
                    option.classList.remove("current-view");
                  });
    
                  option.classList.add("current-view");
    
                  setPriceView(option.dataset.option);
    
                  pricelines.forEach((price, i) => {
                    setTimeout(() => {
                      price.classList.toggle("active");
                    }, 50);
                  });
                });
              });
            }

        });
      }
    }

    function getQueryParam(name) {
      let urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }

    function setPriceView(value) {
      const url = new URL(location);
      url.searchParams.set("priceview", value);
      history.pushState({}, "", url);
    }

    return {
      init: init,
    };
  })();
